module.exports = __webpack_public_path__ + "static/media/stream.778e6bce.svg";